import dataProvider from "dataProvider";

export const updateManySkus = (skuIds, payload) => {
  dataProvider.updateMany("spare-parts", {
    ids: skuIds,
    data: payload,
  });
};
